export type Prettify<T> = {
  [K in keyof T]: T[K];
};

export type FtpUserID = number;
export type SystemUserID = number;
export type ServerID = string;
export type Password = string;
export type HashedPassword = string;
export type DirectoryPath = string;
export type SystemUserName = string;
export type WebsiteID = number;
export type URLString = string;

export enum FtpUserStatus {
  CREATING,
  ACTIVE,
  UPDATING,
  DELETING,
  DELETED,
  ERROR,
  DISABLED,
}

export interface FtpUser {
  id: FtpUserID;
  username: string;
  password: HashedPassword;
  homeDir: DirectoryPath;
  systemUserId: SystemUserID;
  accountName: SystemUserName | null;
  server: ServerID;
  status: FtpUserStatus;
  websiteId: WebsiteID;
}

export interface FtpUserLog {
  id: number;
  log: string;
}

export interface FtpUserWithLogs extends Prettify<FtpUser> {
  logs: FtpUserLog[];
}

export interface FtpUserCreateDTO {
  username: string;
  password: Password;
  systemUserId: SystemUserID;
  server: ServerID;
  websiteId: WebsiteID;
  homeDir: DirectoryPath;
}

export interface FtpUserUpdateDTO {
  password: Password;
}

export interface FtpUserToggleDTO {
  enable: boolean;
}

export interface FtpUserSearchResult {
  total: number;
  limit: number;
  offset: number;
  next: URLString | null;
  prev: URLString | null;
  ftpUsers: FtpUser[];
}
